module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('emoji-picker', {
    attrs: {
      "search": _vm.search
    },
    on: {
      "emoji": _vm.insert
    },
    scopedSlots: _vm._u([{
      key: "emoji-invoker",
      fn: function(ref) {
        var clickEvent = ref.events.click;

        return _c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return clickEvent($event)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "append",
            "type": "text",
            "icon": "fa fa-smile-o"
          },
          slot: "append"
        })], 1)
      }
    }, {
      key: "emoji-picker",
      fn: function(ref) {
        var emojis = ref.emojis;
        var insert = ref.insert;

        return _c('div', {}, [_c('div', {
          staticClass: "emoji-picker"
        }, [_c('div', {
          staticClass: "emoji-picker__search"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.search),
            expression: "search"
          }],
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (_vm.search)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.search = $event.target.value
            }
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "emojis"
        }, _vm._l((emojis), function(emojiGroup, category) {
          return _c('div', {
            key: category
          }, [_c('h5', [_vm._v(_vm._s(category))]), _vm._v(" "), _c('div', _vm._l((emojiGroup), function(emoji, emojiName) {
            return _c('span', {
              key: emojiName,
              attrs: {
                "title": emojiName
              },
              on: {
                "click": function($event) {
                  return insert(emoji)
                }
              }
            }, [_vm._v(_vm._s(emoji))])
          }), 0)])
        }), 0)])])
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d885e4aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/EmojiKeyboard.vue
// module id = 3402
// module chunks = 3